import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { getChannelsByStore, getStoreInfo } from '../../api/stores';



const StoreChannelsPage = () => {
    const { uuid } = useParams();
    const navigate = useNavigate();
    const [스토어, set스토어] = useState(null);
    const [채널목록, set채널목록] = useState([]);
    const [로딩중, set로딩중] = useState(true);
    const [에러, set에러] = useState(null);

    useEffect(() => {
        Promise.all([getStoreInfo(uuid), getChannelsByStore(uuid)])
            .then(([스토어데이터, 채널데이터]) => {
                set스토어(스토어데이터);
                set채널목록(Array.isArray(채널데이터) ? 채널데이터 : []);
            })
            .catch(() => {
                set에러('정보를 불러오지 못했습니다.');
            })
            .finally(() => {
                set로딩중(false);
            });
    }, [uuid]);

    return (
        <PageWrapper>
            <Contents>
                <BackButton onClick={() => navigate('/stores')}>← 스토어 목록</BackButton>

                {로딩중 && <StatusText>불러오는 중...</StatusText>}

                {!로딩중 && 에러 && <StatusText $error>{에러}</StatusText>}

                {!로딩중 && !에러 && (
                    <>
                        <TitleRow>
                            <PageTitle>{스토어?.name ?? '스토어'}</PageTitle>
                        </TitleRow>

                        <SectionLabel>채널 목록</SectionLabel>

                        {채널목록.length === 0 ? (
                            <StatusText>등록된 채널이 없습니다.</StatusText>
                        ) : (
                            <ChannelList>
                                {채널목록.map((채널) => (
                                    <ChannelCard
                                        key={채널.uuid}
                                        onClick={() => navigate(`/stores/${uuid}/channels/${채널.uuid}`)}
                                    >
                                        <ChannelName>{채널.name ?? '이름 없음'}</ChannelName>
                                        {채널.bio && (
                                            <ChannelDescription>{채널.bio}</ChannelDescription>
                                        )}
                                    </ChannelCard>
                                ))}
                            </ChannelList>
                        )}
                    </>
                )}
            </Contents>
        </PageWrapper>
    );
};


const PageWrapper = styled.div`
    width: 100%;
    min-height: 100dvh;
    background: #f7f8fa;
`;

const Contents = styled.div`
    max-width: 960px;
    margin: 0 auto;
    padding: 80px 16px 48px;
`;

const BackButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    margin-bottom: 24px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    color: #999999;
    cursor: pointer;

    &:hover {
        color: #111111;
    }
`;

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
`;

const PageTitle = styled.h1`
    font-family: Pretendard;
    font-size: 24px;
    font-weight: 700;
    color: #111111;
    margin: 0;
`;


const SectionLabel = styled.h2`
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    color: #aaaaaa;
    margin-bottom: 16px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
`;

const ChannelList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const ChannelCard = styled.div`
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 12px;
    padding: 20px 24px;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;

    &:hover {
        background: #f5f8ff;
        border-color: #487BFD;
    }
`;



const ChannelName = styled.span`
    display: block;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    color: #111111;
`;

const ChannelDescription = styled.span`
    display: block;
    margin-top: 6px;
    font-family: Pretendard;
    font-size: 13px;
    font-weight: 400;
    color: #777777;
    line-height: 160%;
`;

const StatusText = styled.span`
    display: block;
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 400;
    color: ${({ $error }) => ($error ? '#EF4444' : '#aaaaaa')};
`;


export default StoreChannelsPage;
